export const menu = [
    {
        menu_sid: "1",
        menu_categories: "3",
        menu_photo: "cake003.jpg",
        menu_name: "海鹽奶蓋千層",
        menu_kcal: "400",
        menu_price_m: "250",
        menu_nutrition:
            "茶香濃郁的紅玉烏龍配上清爽的中澤奶霜，層層堆疊成香甜可口的千層，再淋上用海鹽及奶油乳酪做成的芝芝奶蓋",
        created_at: "2022-07-06 00:00:00",
    },
    {
        menu_sid: "2",
        menu_categories: "1",
        menu_photo: "164854719845.jpg",
        menu_name: "焦糖瑪奇朵",
        menu_kcal: "275.4",
        menu_price_m: "150",
        menu_nutrition: "咖啡因含量:黃101-200mg/杯",
        created_at: "2022-06-11 00:00:00",
    },
    {
        menu_sid: "3",
        menu_categories: "4",
        menu_photo: "5ab90dfb3e5fe6a1c1c3d849b8d64389.jpg",
        menu_name: "芒果金萱貝果",
        menu_kcal: "210",
        menu_price_m: "95",
        menu_nutrition:
            "(全素含酒)台灣愛文芒果乾與帶有花香及牛奶香的金萱茶在Q彈貝果中蹦出新滋味。",
        created_at: "2022-07-11 00:00:00",
    },
    {
        menu_sid: "4",
        menu_categories: "1",
        menu_photo: "164854542119.jpg",
        menu_name: "美式黑咖啡",
        menu_kcal: "23.4",
        menu_price_m: "90",
        menu_nutrition: "咖啡因含量:黃101-200mg/杯",
        created_at: "2022-06-13 00:00:00",
    },
    {
        menu_sid: "5",
        menu_categories: "4",
        menu_photo: "food001.jpeg",
        menu_name: "煙燻鮭魚沙拉",
        menu_kcal: "210",
        menu_price_m: "150",
        menu_nutrition: "含有鮪魚。",
        created_at: "2022-07-18 00:00:00",
    },
    {
        menu_sid: "6",
        menu_categories: "1",
        menu_photo: "164854726399.jpg",
        menu_name: "鴛鴦咖啡",
        menu_kcal: "231.3",
        menu_price_m: "120",
        menu_nutrition: "咖啡因含量:綠100mg/杯",
        created_at: "2022-06-15 00:00:00",
    },
    {
        menu_sid: "7",
        menu_categories: "1",
        menu_photo: "164855348076.jpg",
        menu_name: "香草風味拿鐵",
        menu_kcal: "240.5",
        menu_price_m: "150",
        menu_nutrition: "咖啡因含量:黃101-200mg/杯",
        created_at: "2022-06-16 00:00:00",
    },
    {
        menu_sid: "8",
        menu_categories: "1",
        menu_photo: "164854733355.jpg",
        menu_name: "拿鐵歐蕾",
        menu_kcal: "197.5",
        menu_price_m: "150",
        menu_nutrition: "咖啡因含量:綠100mg以下/杯",
        created_at: "2022-06-17 00:00:00",
    },
    {
        menu_sid: "9",
        menu_categories: "3",
        menu_photo: "cake001.jpg",
        menu_name: "芋泥千層蛋糕",
        menu_kcal: "400",
        menu_price_m: "210",
        menu_nutrition:
            "淡淡茶香的鮮奶油、分量十足又帶著些微顆粒的香甜芋泥這兩個加起來真的讓這款蛋糕變成了芋泥控的最愛",
        created_at: "2022-07-04 00:00:00",
    },
    {
        menu_sid: "10",
        menu_categories: "1",
        menu_photo: "164854662128.jpg",
        menu_name: "莊園級美式",
        menu_kcal: "15.5",
        menu_price_m: "100",
        menu_nutrition: "咖啡因含量:紅201mg/杯",
        created_at: "2022-06-19 00:00:00",
    },
    {
        menu_sid: "11",
        menu_categories: "1",
        menu_photo: "164855352165.jpg",
        menu_name: "莊園級拿鐵",
        menu_kcal: "267.7",
        menu_price_m: "150",
        menu_nutrition: "咖啡因含量:紅201mg/杯",
        created_at: "2022-06-20 00:00:00",
    },
    {
        menu_sid: "12",
        menu_categories: "1",
        menu_photo: "56546546456.jpg",
        menu_name: "哥倫比亞",
        menu_kcal: "4",
        menu_price_m: "110",
        menu_nutrition: "咖啡因含量:黃101-200mg/杯",
        created_at: "2022-06-21 00:00:00",
    },
    {
        menu_sid: "13",
        menu_categories: "1",
        menu_photo: "8797827242.jpg",
        menu_name: "曼巴",
        menu_kcal: "4",
        menu_price_m: "110",
        menu_nutrition: "咖啡因含量:黃101-200mg/杯",
        created_at: "2022-06-22 00:00:00",
    },
    {
        menu_sid: "14",
        menu_categories: "1",
        menu_photo: "191016113J5.jpg",
        menu_name: "黃金曼特寧",
        menu_kcal: "4",
        menu_price_m: "110",
        menu_nutrition: "咖啡因含量:黃101-200mg/杯",
        created_at: "2022-06-23 00:00:00",
    },
    {
        menu_sid: "15",
        menu_categories: "1",
        menu_photo: "164855352165.jpg",
        menu_name: "肯亞 精選小農",
        menu_kcal: "4",
        menu_price_m: "110",
        menu_nutrition: "咖啡因含量:黃101-200mg/杯",
        created_at: "2022-06-24 00:00:00",
    },
    {
        menu_sid: "16",
        menu_categories: "1",
        menu_photo: "164854707440.jpg",
        menu_name: "莊園老饕深焙",
        menu_kcal: "4",
        menu_price_m: "110",
        menu_nutrition: "咖啡因含量:黃101-200mg/杯",
        created_at: "2022-06-25 00:00:00",
    },
    {
        menu_sid: "17",
        menu_categories: "1",
        menu_photo: "164854722465.jpg",
        menu_name: "耶加雪菲",
        menu_kcal: "4",
        menu_price_m: "110",
        menu_nutrition: "咖啡因含量:黃101-200mg/杯",
        created_at: "2022-06-26 00:00:00",
    },
    {
        menu_sid: "18",
        menu_categories: "2",
        menu_photo: "164854805159.jpg",
        menu_name: "義式巧克力",
        menu_kcal: "378",
        menu_price_m: "95",
        menu_nutrition: "總糖量:64.1公克",
        created_at: "2022-06-27 00:00:00",
    },
    {
        menu_sid: "19",
        menu_categories: "2",
        menu_photo: "164855343790.jpg",
        menu_name: "愛丁堡女王紅茶",
        menu_kcal: "50",
        menu_price_m: "70",
        menu_nutrition: "茶葉產地:印度、斯里蘭卡、尼泊爾、台灣、越南",
        created_at: "2022-06-28 00:00:00",
    },
    {
        menu_sid: "20",
        menu_categories: "2",
        menu_photo: "164854810839.jpg",
        menu_name: "宇治奶茶",
        menu_kcal: "345",
        menu_price_m: "95",
        menu_nutrition: "茶葉產地:日本京都府",
        created_at: "2022-06-29 00:00:00",
    },
    {
        menu_sid: "21",
        menu_categories: "2",
        menu_photo: "164855321093.jpg",
        menu_name: "清韻不知春",
        menu_kcal: "0",
        menu_price_m: "80",
        menu_nutrition: "茶葉產地:台灣。",
        created_at: "2022-06-30 00:00:00",
    },
    {
        menu_sid: "22",
        menu_categories: "2",
        menu_photo: "164855327768.jpg",
        menu_name: "蜜沁紅烏龍",
        menu_kcal: "0",
        menu_price_m: "80",
        menu_nutrition: "茶葉產地:台灣。",
        created_at: "2022-07-01 00:00:00",
    },
    {
        menu_sid: "23",
        menu_categories: "2",
        menu_photo: "164855332635.jpg",
        menu_name: "烏潤鐵觀音",
        menu_kcal: "0",
        menu_price_m: "80",
        menu_nutrition: "茶葉產地:台灣。",
        created_at: "2022-07-02 00:00:00",
    },
    {
        menu_sid: "24",
        menu_categories: "2",
        menu_photo: "164855348076.jpg",
        menu_name: "雲霧渾紅玉拿鐵",
        menu_kcal: "150",
        menu_price_m: "120",
        menu_nutrition: "茶葉產地:台灣。",
        created_at: "2022-07-03 00:00:00",
    },
    {
        menu_sid: "25",
        menu_categories: "1",
        menu_photo: "164854671498.jpg",
        menu_name: "卡布奇諾",
        menu_kcal: "260.5",
        menu_price_m: "150",
        menu_nutrition: "咖啡因含量:黃101-200mg/杯",
        created_at: "2022-06-12 00:00:00",
    },
    {
        menu_sid: "26",
        menu_categories: "3",
        menu_photo: "cake002.jpg",
        menu_name: "抹茶千層蛋糕",
        menu_kcal: "400",
        menu_price_m: "220",
        menu_nutrition:
            "用了清爽的中澤奶霜配上帶著濃郁微苦的小山園若竹抹茶，香濃卻不膩口，就算是不太愛抹茶的人也都會被圈粉\r\n達30幾層的厚度更是讓抹茶控吃了幸福到瘋掉～～",
        created_at: "2022-07-05 00:00:00",
    },
    {
        menu_sid: "28",
        menu_categories: "3",
        menu_photo: "cake004.jpg",
        menu_name: "開心果千層蛋糕",
        menu_kcal: "400",
        menu_price_m: "200",
        menu_nutrition:
            "法國鹽之花加入熬煮到微苦焦香的太妃糖醬配上清爽的中澤奶霜，夾層是濃郁的義大利進口開心果醬,帶著淡淡苦味卻鹹香不甜膩的鮮奶油配上濃郁的堅果真的是一款有著不同層次又很耐吃的蛋糕",
        created_at: "2022-07-07 00:00:00",
    },
    {
        menu_sid: "29",
        menu_categories: "1",
        menu_photo: "164854563274.jpg",
        menu_name: "咖啡拿鐵",
        menu_kcal: "381.4",
        menu_price_m: "150",
        menu_nutrition: "咖啡因含量:黃101-200mg/杯",
        created_at: "2022-06-10 00:00:00",
    },
    {
        menu_sid: "30",
        menu_categories: "4",
        menu_photo: "aa590fde0c648a9023ae4c15df9acdf8.jpg",
        menu_name: "黑糖黑芝麻貝果 \n",
        menu_kcal: "210",
        menu_price_m: "85",
        menu_nutrition:
            "以台南關山手工黑糖與100%的黑芝麻醬製成飽滿內餡，再撒上黑芝麻讓香氣更加濃郁。",
        created_at: "2022-07-09 00:00:00",
    },
    {
        menu_sid: "31",
        menu_categories: "4",
        menu_photo: "1a1c87a85a55d7df8409e3cbc069a6cc.jpg",
        menu_name: "柚子鳳梨貝果",
        menu_kcal: "210",
        menu_price_m: "85",
        menu_nutrition:
            "將在地新鮮柚子果乾浸入清甜白酒中增添風味，讓每一口都是香甜鳳梨與清甜柚子交融的豐厚果香。",
        created_at: "2022-07-10 00:00:00",
    },
    {
        menu_sid: "33",
        menu_categories: "4",
        menu_photo: "36e4875bb0c36b591b450cd62b7328b0.jpg",
        menu_name: "地瓜乳酪貝果",
        menu_kcal: "210",
        menu_price_m: "80",
        menu_nutrition:
            "將充滿這塊土地甘甜的紅地瓜，帶皮拌入乳酪中，柔軟綿密的口感裡盡是台灣人熟悉的純樸美味。",
        created_at: "2022-07-12 00:00:00",
    },
    {
        menu_sid: "34",
        menu_categories: "4",
        menu_photo: "1260bdcb0bff7f62f079484530475064.jpg",
        menu_name: "桂花紫薯貝果",
        menu_kcal: "210",
        menu_price_m: "95",
        menu_nutrition:
            "富含營養的台灣紫薯內餡，帶著高雅的桂花清香，花香與紫薯獨特香氣交融，讓人愛不釋口。",
        created_at: "2022-07-13 00:00:00",
    },
    {
        menu_sid: "35",
        menu_categories: "4",
        menu_photo: "666ba1c59d2ee8cf1b1dfe912e4c6d72.jpg",
        menu_name: "塔香番茄貝果",
        menu_kcal: "210",
        menu_price_m: "80",
        menu_nutrition:
            "將自製的聖女番茄乾與九層塔葉揉入番茄風味的麵團中，讓香草與果物相互交疊出獨特的鹹甜滋味。",
        created_at: "2022-07-14 00:00:00",
    },
    {
        menu_sid: "36",
        menu_categories: "4",
        menu_photo: "033bb88d4b83dc57eeab8c314e1ca303.jpg",
        menu_name: "紅豆牛奶貝果",
        menu_kcal: "210",
        menu_price_m: "80",
        menu_nutrition:
            "將友善種植的老鷹紅豆與純鮮奶煉乳融合成甘甜的紅豆牛奶內餡，豆香與奶韻交融出樸實美味。",
        created_at: "2022-07-15 00:00:00",
    },
    {
        menu_sid: "37",
        menu_categories: "4",
        menu_photo: "6cf2aa671b457aedf54199f78f2da1ca.jpg",
        menu_name: "蔥蒜乳酪貝果",
        menu_kcal: "210",
        menu_price_m: "75",
        menu_nutrition:
            "揉進三星蔥麵團裡的是煙燻德式香腸丁和新鮮大蒜泥製成的蒜香乳酪，辛香夠味讓人胃口大開。",
        created_at: "2022-07-16 00:00:00",
    },
    {
        menu_sid: "38",
        menu_categories: "4",
        menu_photo: "26ce93efeb19c4cf9d6c89a6579fbcd5.jpg",
        menu_name: "四季春貝果",
        menu_kcal: "210",
        menu_price_m: "85",
        menu_nutrition:
            "將東台灣帶著淡雅梔子花香的原片茶葉細磨拌入麵團，尾韻甘甜帶有烏龍韻味及清新茶香。",
        created_at: "2022-07-17 00:00:00",
    },
    {
        menu_sid: "39",
        menu_categories: "1",
        menu_photo: "164854815086.jpg",
        menu_name: "義式摩卡",
        menu_kcal: "368",
        menu_price_m: "150",
        menu_nutrition: "咖啡因含量:黃101-200mg/杯",
        created_at: "2022-06-18 00:00:00",
    },
    {
        menu_sid: "40",
        menu_categories: "4",
        menu_photo: "salad001.jpeg",
        menu_name: "花椰菜嫩豬沙拉",
        menu_kcal: "210",
        menu_price_m: "180",
        menu_nutrition: "含有台灣豬肉。",
        created_at: "2022-07-19 00:00:00",
    },
    {
        menu_sid: "41",
        menu_categories: "1",
        menu_photo: "164854654357.jpg",
        menu_name: "黑糖風味拿鐵",
        menu_kcal: "375.2",
        menu_price_m: "150",
        menu_nutrition: "咖啡因含量:黃101-200mg/杯",
        created_at: "2022-06-14 00:00:00",
    },
    {
        menu_sid: "42",
        menu_categories: "3",
        menu_photo: "574545454524.png",
        menu_name: "焦糖脆脆千層",
        menu_kcal: "400",
        menu_price_m: "190",
        menu_nutrition:
            "鹹香濃郁的鹹蛋黃慕斯配上微苦脆口的焦糖脆脆，再來一個爽口的香草鮮奶油中和，真的會吃到停不下來完全不膩口",
        created_at: "2022-07-08 00:00:00",
    },
];
